import React, { useState, useContext } from 'react';
import { UserContext  } from './UserContext'; // Importa il contesto utente
import { useNavigate } from 'react-router-dom'; // Importa useNavigate
function Login() {
  const annoCorrente = new Date().getFullYear();
  const { setUserData } = useContext(UserContext);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate(); // Ottieni la funzione navigate
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null); // Resetta eventuali errori precedenti

    try {
      const response = await fetch(`/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: username, password }),
        credentials: 'include'
      });

      if (response.ok) {
        // Login riuscito
        const data = await response.json();
        const userData = { // Costruisci l'oggetto userData completo
            item: data.user._id,
            nome: data.user.nome,
            cognome: data.user.cognome,
            mail: data.user.mail,
            role: data.user.role,
            ragioneSociale: data.user.ragioneSociale,
            indirizzo: data.user.indirizzo,
            comune: data.user.comune,
            prov: data.user.prov,
            tel: data.user.tel,
            cell: data.user.cell,
            codFisc: data.user.codFisc,
            piva: data.user.piva,
            ore: data.user.ore,
            residue: data.user.residue,
            regime: data.user.regime,
            ritenuta: data.user.ritenuta,
            id_operatore: data.user.id_operatore,
            formazione: data.user.formazioneObbligatoria,
            planId: data.user.planId,
            plan: data.user.plan,
            stripeProdId: data.user.stipeProdId,
            stripePriceId: data.user.stripePriceId,
        };
        localStorage.setItem('user', JSON.stringify(userData)); // Salva nel localStorage
        localStorage.setItem('token', data.token); // Salva il token
        setUserData(userData); // <-- Questo è fondamentale per aggiornare il contesto

        
        // Reindirizzamento in base al ruolo
        if (data.user.role === 'user') {
          const schedaUtenteResponse = await fetch(`/api/scheda-utente/${userData.item}`, {
            headers: {
                'Content-Type': 'application/json'
            }
          });
          const schedaUtenteData = await schedaUtenteResponse.json();
          if (!schedaUtenteData.stripeStatus) {
            navigate(`/setup-pagamento`);
          } else {
            navigate('/dashboard');
          }
        } else if (data.user.role === 'operatore') {
          navigate('/gestione/dashboard');
        } else if (data.user.role === 'superAdmin') {
          navigate('/amministratore/dashboard');
        } else {
          setError('Ruolo utente non valido');
        }
      } else {
        // Login fallito
        const errorData = await response.json();
        setError(errorData.error || 'Credenziali non valide');
      }
    } catch (err) {
      // console.error('Errore durante il login:', err);
      setError('Si è verificato un errore durante il login');
    }
  };

  return (
    <div className="main_content_iner">
      <div className="container-fluid body_white_bg plr_30 pt_30 pb_30">
        <div className="row justify-content-center mt-5 pt_30 pb_30">
          <div class="col-lg-6 col-sm-8 col-xs-12">
            <div className="modal-content cs_modal">
              <div className="modal-header flexxa">
                <h5 className="modal-title">Accedi ad Animus Operandi</h5>
                <img src="/img/logo-animus-operandi.png" alt="Animus Operandi" className="logologin"></img>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  <div>
                    <input className="form-control" type="text" id="email" placeholder="Nome Utente, ovvero la tua e-mail" value={username} onChange={(e) => setUsername(e.target.value)} />
                  </div>
                  <div>
                    <input className="form-control" type="password" id="password" placeholder="La tua password" value={password} onChange={(e) => setPassword(e.target.value)} />
                  </div>
                  <button type="submit" className="btn_1 full_width text-center">Accedi</button>
                  {error && <p className="error-message text-danger"><b>Attenzione: </b>{error}</p>}
                  <p>Non disponi di un account? <a data-bs-toggle="modal" data-bs-target="#sing_up" data-bs-dismiss="modal"
                                href="https://www.animusoperandi.it"> Richiedi un contatto!</a></p>
                  <div className="text-center">
                    <a href="/recupera-password" data-bs-toggle="modal" data-bs-target="#forgot_password" data-bs-dismiss="modal" className="pass_forget_btn">Password dimenticata?</a>
                        </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div style={{minHeight: '120px'}}> </div>
      </div>
      <div className="footer_partGen justify-content-center">
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12 col-sm-12">
                    <div className="footer_iner text-center">
                        <p>© {annoCorrente} Animus Operandi -  Designed & Developed by <a href="https://stefanocoggiola.com/" target="_blank" rel="noreferrer">Stefano Coggiola</a></p>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
}

export default Login;